<template>
  <div class="wrap">
    <div class="title">
      蔵衛門IDパスワード再設定
    </div>
    <ValidationObserver tag="form">
      <div class="row">
        <ValidationInput field-name="パスワード"
                         meta-name="password"
                         :valid-rules="passwordRules"
                         ref="passwordInput">
          <input type="password"
                 placeholder="新しいパスワード"
                 v-model="password" />
        </ValidationInput>
      </div>
      <div class="row">
        <ValidationInput field-name="パスワード確認"
                         :valid-rules="passwordConfirmRules"
                         ref="passwordConfirmInput">
          <input type="password"
                 placeholder="パスワード(確認)"
                 v-model="passwordConfirm" />
        </ValidationInput>
      </div>
    </ValidationObserver>
    <div class="btn-wrap">
      <button class="btn next-btn"
              @click="resetPass"
              :disabled="!isValid()">
        次へ
      </button>
    </div>
  </div>
</template>

<script>
import ValidationInput from '@/components/ui/ValidationInput.vue'
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'Form',
  components: {
    ValidationInput,
    ValidationObserver
  },
  data() {
    return {
      password: '',
      passwordConfirm: '',
      passwordRules: {
        required: true,
        regex: /^[\x21-\x7e]+$/,
        min: { length: 8 },
        max: { length: 32 },
        pass_strength: true
      },
      passwordConfirmRules: {
        required: true,
        confirmed: 'password'
      }
    }
  },
  props: {
    reset: Object,
    onetimeToken: String
  },
  methods: {
    resetPass() {
      const args = {
        onetime_token: this.onetimeToken,
        password: this.password
      }
      this.$store.dispatch('api/resetKuraemonIdPassword', args).then(() => {
        if (this.$store.getters['api/apiError']) {
          return;
        }
        this.reset.editState = 'checked';
        this.$router.replace({ name: 'reset-password-complete' })
      })
    },
    isValid() {
      if (!this.$refs.passwordInput
        || !this.$refs.passwordConfirmInput) return;
      return this.$refs.passwordInput.$children[0].flags.valid
        && this.$refs.passwordConfirmInput.$children[0].flags.valid;
    }
  },
}
</script>

<style scoped>
.wrap {
  width: 500px;
  margin: auto;
  padding: 1rem;
  text-align: center;
}
.title {
  font-size: 1.4rem;
  font-weight: bold;
  margin: 4rem 0 6rem 0;
  text-align: center;
}
.row {
  margin: 1rem 0;
}
input {
  border: solid 1px #333;
  border-radius: 0.5rem;
  padding: 0.75rem 0.5rem;
  width: 100%;
}
.btn-wrap {
  margin-top: 3rem;
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.next-btn {
  background-color: #333;
  color: white;
}
.next-btn:disabled {
  background-color: #999;
  color: #ccc;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>